module.exports = __webpack_public_path__ + "assets/img/510c-eu.svg";